var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TurningOffReasonsSwitch',{staticClass:"locationSwitch ml-5 mt-1",attrs:{"value":_vm.hasAllRestaurantsActive},on:{"selected":_vm.switchStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }